import * as React from 'react';

import { Binding } from 'core/infrastructure';
import { cloneExcept, Environment } from '../../utils';
import { FormComponent } from './Form';
import { Constraint, positive } from './Constraints';
import { TextBox, TextBoxCtor } from './TextBox';

interface Props<T> extends React.DetailedHTMLProps<React.InputHTMLAttributes<IntBox<T>>, IntBox<T>> {
	linkTo: Binding.PropertyPath<T>;
	label?: string | React.ReactNode;
	rules?: Constraint | Constraint[];
	onEnterPress?: () => void;
	onValueChange?: (value: string) => void;
	boundValue?: any;
	allowNegative?: boolean;
	childrenPosition?: 'append' | 'prepend'
}

export class IntBox<T> extends React.Component<Props<T>, EmptyState> implements FormComponent {

	constructor(props: Props<T>) {
		super(props);
	}

	private textBox = React.createRef<TextBox<T>>();

	getPath() {
		return this.textBox.current!.getPath();
	}

	showErrors(errors: string[]) {
		this.textBox.current!.showErrors(errors);
	}

	getValue() {
		return this.textBox.current!.getValue();
	}

	activate() {
		this.textBox.current!.activate();
	}

	clear() {
		this.textBox.current!.clear();
	}

	render() {
		const TheTextBox: TextBoxCtor<T> = TextBox;

		const props = cloneExcept(this.props, ['ref', 'allowNegative']);
		props.rules = !props.rules ? [] : typeof props.rules === 'function' ? [props.rules] : props.rules;

		if (!this.props.allowNegative) {
			props.rules.push(positive);
			props.min = 0;
		}

		props.propertyType = 'int';
		props.autoComplete = 'off';

		// Dejo text y gestiono a mano lo que se puede poner y lo que no
		// para poder usar el . del teclado numérico en navegadores como Chrome
		// Para los dispositivos móviles mantenemos el type por si se quiere
		// usar el tipo tel o cualquier otro.
		if (!Environment.isMobile())
			props.type = 'text';

		return <TheTextBox ref={this.textBox} {...props} />;
	}
}

export type IntBoxCtor<T> = new (props: Props<T>) => IntBox<T>;
